// extracted by mini-css-extract-plugin
export default {"card":"SupportRequests_card__ijswJ","title":"SupportRequests_title__KqIW9"};